/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free discount calculator. Enter the original price and discount percentage to see the sale price and how much you save.`)
};

const es_pct_discount_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de descuento gratuita. Introduce el precio original y el porcentaje de descuento para ver el precio de venta y cuánto ahorras.`)
};

const de_pct_discount_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Rabattrechner. Gib den Originalpreis und den Rabatt-Prozentsatz ein, um den Verkaufspreis und deine Ersparnis zu sehen.`)
};

const nl_pct_discount_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis kortingscalculator. Vul de oorspronkelijke prijs en het kortingspercentage in voor de verkoopprijs en hoeveel je bespaart.`)
};

const fr_pct_discount_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de réduction gratuit. Entrez le prix d'origine et le pourcentage de réduction pour voir le prix soldé et le montant économisé.`)
};

const it_pct_discount_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di sconti gratuito. Inserisci il prezzo originale e la percentuale di sconto per vedere il prezzo finale e quanto risparmi.`)
};

const pt_br2_pct_discount_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de desconto gratuita. Insira o preço original e a porcentagem de desconto para ver o preço de venda e quanto você economiza.`)
};

const pt_pct_discount_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de desconto gratuita. Insira o preço original e a percentagem de desconto para ver o preço de venda e quanto poupa.`)
};

const ja_pct_discount_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の割引計算機。元の価格と割引率を入力すると、セール価格と節約額が分かります。`)
};

const zh_pct_discount_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费折扣计算器。输入原价和折扣比例，查看促销价及节省金额。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_meta_description", locale)
	if (locale === "en") return en_pct_discount_meta_description(inputs)
	if (locale === "es") return es_pct_discount_meta_description(inputs)
	if (locale === "de") return de_pct_discount_meta_description(inputs)
	if (locale === "nl") return nl_pct_discount_meta_description(inputs)
	if (locale === "fr") return fr_pct_discount_meta_description(inputs)
	if (locale === "it") return it_pct_discount_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_meta_description(inputs)
	if (locale === "pt") return pt_pct_discount_meta_description(inputs)
	if (locale === "ja") return ja_pct_discount_meta_description(inputs)
	return zh_pct_discount_meta_description(inputs)
};